<router-outlet *ngIf="tn.isLoadingView"></router-outlet>
<div class="Language">
    <select *ngIf="Language && tn.isLoadingView" (change)="tn.changeLanguage(codelg.value)" #codelg>
        <option [value]="lg.code" *ngFor="let lg of Language" [selected]="this.tn.actionLanguage == lg.code">{{lg.code}}</option>
    </select>
    
</div>